import { Grade, Pricing } from '../../types/pricing';
import { firestore } from '../index';

import { transformProposal } from './transformProposal';

export const getProposalData = async (region: string, grade: Grade = Grade.A): Promise<Pricing[]> => {
  const priceRef = await firestore
    .collection('pricing')
    .where('grade', '==', grade)
    .where('region', '==', region)
    .get();

  if (priceRef.empty) {
    return [];
  }

  return priceRef.docs
    .map(transformProposal)
    .filter(i => !!i) as Pricing[];
};